import {Component, HostBinding, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-panel',
    templateUrl: './panel.component.html',
    styleUrls: ['./panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PanelComponent {
    public opened = true;

    @HostBinding('class.opened')
    get openedClass() {
        return this.opened;
    }

    public toggle() {
        this.opened = !this.opened;
    }
}
